import styled from 'styled-components';

import { Button } from '@/ui/Button';

export const RootStyled = styled.div`
  width: fit-content;
`;

export const InnerCircleContentStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: relative;
`;

export const EffortDescriptionBoxStyled = styled.div`
  text-align: center;
  margin-top: 45px;
`;

export const CurrentEffortStyled = styled.div`
  ${({ theme }) => theme.typography.title2};
  color: ${({ theme }) => theme.colors.neutral.onBackground};
`;

export const ExpectedEffortStyled = styled.div`
  ${({ theme }) => theme.typography.caption};
  color: ${({ theme }) => theme.colors.neutral.outline2};
`;

export const AddLearningTimeBox = styled.div`
  position: absolute;
  right: 10%;
`;

export const ActionsContainerStyled = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: center;
`;

export const ViewDetailsButtonStyled = styled(Button)`
  margin-top: 12px;
  display: inline-flex;
  ${({ theme }) => theme.typography.body3};
`;
